import * as ActionTypes from './actionTypes';

export default function translationsReducer(state = {}, { type, payload }) {
    switch (type) {
        case ActionTypes.TRANSLATIONS_DATA_UPDATE:
            return {
                ...state,
                ...payload
            };
        default :
            return state;
    }
    
}